import { Component, h, Host, Prop } from "@stencil/core";

@Component({
    tag: "ux-popover-panel-arrow",
    styleUrl: "./popover-panel-arrow.scss"
})
export class PopoverPanelArrow {
    /** Indicates that the arrow should render with border */
    // eslint-disable-next-line @stencil-community/ban-default-true
    @Prop({ reflect: true }) readonly border = true;
    render() {
        const baseClass = "ux-popover-panel-arrow";
        return (
            <Host>
                {this.border && (
                    <span
                        class={{
                            [baseClass]: true,
                            [`${baseClass}__border`]: true
                        }}
                    />
                )}
                <span
                    class={{
                        [baseClass]: true,
                        [`${baseClass}__fill`]: true
                    }}
                />
            </Host>
        );
    }
}
